export const PIXEL_ID = '2314168986055344'

type FbqArgs = unknown[]

interface FbqFunction {
  (...args: FbqArgs): void
  callMethod?: (...args: FbqArgs) => void
  queue: FbqArgs[]
  push: unknown
  loaded: boolean
  version: string
}

declare global {
  interface Window {
    fbq?: FbqFunction
    _fbq?: FbqFunction
  }
}

/**
 * Injects the Meta Pixel base code once, then fires the initial PageView.
 * Mirrors the official snippet, adapted to run from React.
 */
export function loadMetaPixel(): void {
  if (typeof window === 'undefined') return

  if (!window.fbq) {
    const fbq = function (...args: FbqArgs) {
      if (fbq.callMethod) {
        fbq.callMethod(...args)
      } else {
        fbq.queue.push(args)
      }
    } as FbqFunction

    fbq.queue = []
    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'

    window.fbq = fbq
    if (!window._fbq) window._fbq = fbq

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)

    const noscript = document.createElement('noscript')
    const pixelImg = document.createElement('img')
    pixelImg.height = 1
    pixelImg.width = 1
    pixelImg.style.display = 'none'
    pixelImg.alt = ''
    pixelImg.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
    noscript.appendChild(pixelImg)
    document.body.appendChild(noscript)
  }

  window.fbq?.('init', PIXEL_ID)
  window.fbq?.('track', 'PageView')
}

/** Fires a standard Meta Pixel event, safely ignored if the pixel is blocked. */
export function trackPixelEvent(
  event: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', event, params)
}
